import Base from '@studiometa/js-toolkit';
import Cookies from 'js-cookie';
import { isDev } from '../config';

/**
 * ProfilSelectorHomepage class.
 *
 */
export default class ProfilSelectorHomepage extends Base {
  /**
   * App configuration.
   * @return {Object}
   */
  get config() {
    return {
      name: 'ProfilSelectorHomepage',
      log: isDev(),
      refs: ['btn[]'],
    };
  }

  /**
   * Get Current User Profile
   *
   * @return {String} Current User Profile from Session Cookies
   */
  get currentProfile() {
    return Cookies.get('current_profile');
  }

  /**
   * Set Current User Profile
   *
   * @param {string} value New profile value
   */
  set currentProfile(value) {
    Cookies.set('current_profile', value);
  }

  /**
   * Toggle dropdown
   * @return {void}
   */
  onBtnClick(e) {
    e.preventDefault();
    this.currentProfile = e.currentTarget.dataset.slug;
    window.location.href = e.currentTarget.href;
  }
}
